import {getAccessToken} from '~/utils/getAccessToken';

export const apiFetch = async (request, opts) => {
  const config = useRuntimeConfig();
  const {accessToken, activeOrg} = await getAccessToken();
  if (!accessToken) return false;
  return $fetch(request, {
    baseURL: config.public.apiBaseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Vector-Org': activeOrg || null,
    },
    ...opts,
  });
};
